import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-overview-tab-2-part',
	standalone:true,
	templateUrl: './admissions-overview-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-overview-tab-2.part.scss`],
})
export class AdmissionsOverviewTab2Part {
}
